export const IN_PROGRESS = "inProgress"
export const CLOSE_TO_DISPATCH = "closeToDispatch"
export const RECENTLY_ACTIVATED = "recentlyActivated"
export const SCHEDULED = "scheduled"
export const DISPATCHED = "dispatched"
export const EXTRA_SERVICES = "extraServices"
export const MARKET_PLACE="marketPlace"

// DEPARTURE FOOTER BUCKET
export const ON_THE_ROAD = 4
export const NEAR_BY = 5
export const ENDED = 6
export const PARTIALLY_ARRIVED = 7
export const SCHEDULED_DEPARTURES = 2
export const SERVICE_RECOVERY = 8